const CampaignCameraIcon = ({ className }: { className?: string }) => (
  <svg
    width="46"
    height="36"
    viewBox="0 0 46 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g clipPath="url(#campaign-camera-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 10.9694C17.8288 10.9694 13.6278 15.1534 13.6278 20.3099C13.6278 25.4664 17.826 29.6504 23 29.6504C28.174 29.6504 32.3722 25.4664 32.3722 20.3099C32.3722 15.1534 28.174 10.9694 23 10.9694ZM20.4663 13.2875C18.8701 13.7751 17.5035 14.8429 16.6316 16.3002C15.7488 17.7712 15.4372 19.5254 15.7433 21.2252C15.7816 21.4431 15.6449 21.6528 15.4263 21.7046C15.2158 21.7536 14.9944 21.7128 14.8168 21.5902C14.6391 21.4676 14.5216 21.2769 14.4915 21.0645C14.2373 19.1822 14.6227 17.2645 15.5957 15.641C16.566 14.023 18.0501 12.8136 19.7912 12.2007C19.9935 12.1298 20.2176 12.1489 20.4062 12.2497C20.5948 12.3532 20.7314 12.5303 20.7806 12.74C20.8353 12.977 20.6986 13.214 20.4663 13.2875Z"
        fill="#2A2422"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.8001 5.64952C44.0321 4.93584 42.988 4.53541 41.9002 4.53541H32.8806L32.0114 2.1247C31.5522 0.855327 30.2731 0 28.8299 0H17.2193C15.7898 0 14.5161 0.841707 14.0487 2.09473L13.1386 4.53541H4.09982C3.012 4.53541 1.97065 4.93584 1.19988 5.64952C0.431848 6.36047 0 7.33021 0 8.33808V32.1973C0 33.2052 0.431848 34.1722 1.19988 34.8859C1.96791 35.5996 3.012 36 4.09982 36H41.9002C42.988 36 44.0294 35.5996 44.8001 34.8859C45.5682 34.1722 46 33.2052 46 32.1973V8.33808C46 7.33021 45.5682 6.3632 44.8001 5.64952ZM23 33.2461C15.8335 33.2461 10.0172 27.4495 10.0172 20.3072C10.0172 13.165 15.8335 7.36834 23 7.36834C30.1665 7.36834 35.9828 13.165 35.9828 20.3072C35.9828 27.4495 30.1665 33.2461 23 33.2461ZM42.2774 9.29419C42.2774 9.61017 42.0204 9.86895 41.7007 9.86895H38.7296C38.4126 9.86895 38.1529 9.61289 38.1529 9.29419V7.9431C38.1529 7.62712 38.4099 7.36834 38.7296 7.36834H41.7007C42.0177 7.36834 42.2774 7.62439 42.2774 7.9431V9.29419Z"
        fill="#2A2422"
      />
    </g>
    <defs>
      <clipPath id="campaign-camera-clip">
        <rect width="46" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CampaignCameraIcon;
